import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { HbaseObjectDataset } from 'app/model/dataset/hbase.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HbaseObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class HbaseObjectDatasetAdapter extends TabularTypeDatasetAdapter<HbaseObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: HbaseObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(HbaseObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: HbaseObjectDataset): Promise<HbaseObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset,  HbaseObjectDataset.MODEL);
    }
}
